import store from "@/store/";

export const setLayout = (to, form, next) => {
  const layout = to.meta.layout;
  if (layout) {
    store.commit("ui/SET_LAYOUT", layout);
  }
  next();
};
